import React, {useContext, useEffect, useState, useRef} from 'react';
import AuditTrail from './AuditTrail';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../loader/Loader';
import uniqid from 'uniqid';
import {getAllAudit} from '../../services/auditTrail';
import Swal from 'sweetalert2';
import {t} from 'react-switch-lang';


const AuditTrailsList = (props) => {
  const {activeRisk, auditAdded, id} = props;
  const [hasMore, setHasMore] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [audit, setAudit] = useState([]);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const listId = uniqid();
  const unmounted = useRef(false);

  let comment = {};

  const fetchData = () => {
    setHasMore(true);
    setPageNumber(0);

    getAllAudit(id, activeRisk, 0)
      .then((r) => {
        if (!unmounted.current) {
          onFetchSuccess(r);
        }
      })
      .catch((r) => {
        if (!unmounted.current) {
          onFetchFailed(r);
        }
      });
  };

  const onFetchSuccess = (r) => {
    if (r.data.length !== 0) {
      setAudit(r.data);
      setIsLoadingPage(false);
      setPageNumber(1);
    } else {
      setAudit(r.data);
      setIsLoadingPage(false);
      setHasMore(false);
    }
  };

  const onFetchFailed = (r) => {
    setIsLoadingPage(false);
    // Swal.fire({
    //   text: `${t('message.errorApi')}`,
    //   icon: 'error',
    //   confirmButtonText: 'Ok',
    // });
  };

  const onFetchMoreSuccess = (r) => {
    if (r.data.length !== 0) {
      const newData = audit;
      r.data.map((item) => newData.push(item));
      setAudit(newData);
      setPageNumber(pageNumber + 1);
    } else {
      setHasMore(false);
    }
  };

  const fetchMoreData = (id) => {
    if (!unmounted.current) {
      getAllAudit(activeRisk.id, pageNumber)
        .then((r) => onFetchMoreSuccess(r))
        .catch((r) => onFetchFailed(r));
    }
  };

  useEffect(() => {
    fetchData();
  }, [auditAdded, activeRisk]);

  useEffect(() => {
    return () => {
      unmounted.current = true;
    };
  }, []);

  return (
    <div className="document-audits-list" id={listId}>
      {isLoadingPage && <Loader />}
      <InfiniteScroll
        dataLength={audit.length}
        next={fetchMoreData}
        hasMore={false}
        scrollableTarget={listId}
        scrollThreshold={0.7}
        loader={<Loader />}
      >
        {audit.map((audit) => {
          return <AuditTrail audit={audit} key={uniqid()} />;
        })}
      </InfiniteScroll>
    </div>
  );
};

export default AuditTrailsList;